import { dotCase } from 'change-case'

export default {
    data: () => ({
        sideBarLinks: [],
        _linkGroups: [],
    }),

    watch: {
        '$router.options.routes': {
            handler: function (to) {
                this.createLinkGroups(to)
            },
            deep: true,
        },
    },

    created() {
        this.createLinkGroups(this.$router.options.routes)
    },
    computed: {
        flattedLinks() {
            return this._linkGroups.reduce((_links, _group) => {
                _links = [..._links, ...(_group.children || [])]
                return _links
            }, [])
        },

        linkGroups() {
            return this._linkGroups.reduce((_groups, _group) => {
                const children = _group.children.filter(
                    x => (x.name == 'orders' || x.permitted) && x.displayName != "activity_assigned_to_others"
                )
                if (children.length > 0) {
                    this.$set(_group, 'children', children)
                    _groups.push(_group)
                }
                return _groups
            }, [])
        },
    },

    methods: {
        getIconName(name) {
            return (
                this.flattedLinks.find(
                    x => x.name.toLowerCase() === name.toLowerCase()
                ) || {}
            ).icon
        },
        isPermitted(name) {
            return !!(
                this.flattedLinks.find(
                    x => x.name.toLowerCase() === name.toLowerCase()
                ) || {}
            ).permitted
        },
        createLinkGroups(routes) {
            const user_permissions = this.$store.getters.user_permissions
            const dashboardLayout = routes.find(
                x => x.name === 'dashboardLayout'
            )
            this._linkGroups = []

            for (let route of dashboardLayout.children) {
                const {
                    path,
                    name,
                    meta: { requiresAuth, requiresAdmin, group, icon, displayName },
                } = route

                const slug = `view.${dotCase(name)}`
                if (group && requiresAuth && requiresAdmin) {
                    let idx = this._linkGroups.findIndex(x => x.group === group)

                    let groupLink = {}
                    let children = []

                    if (idx < 0) {
                        idx = this._linkGroups.length
                    } else {
                        children = this._linkGroups[idx].children
                    }

                    this.$set(groupLink, 'group', group)
                    this.$set(groupLink, 'children', children)

                    const permitted = user_permissions.includes(slug)

                    groupLink.children.push({
                        name,
                        icon,
                        path,
                        permitted,
                        displayName
                    })
                    this._linkGroups.splice(idx, 1, groupLink)
                }
            }
        },
    },
}
